var _a, _b;
import { __decorate, __metadata } from "tslib";
import { I18nService } from '@/services/i18n-service';
import { Message } from '@patsnap/tahiti-core/common/message';
import { isPsHttpError } from '@patsnap/tahiti-core/common/ps-http';
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import Vue from 'vue';
import { isToastError } from '../utils/toast-error';
import { isToastWarning } from '../utils/toast-warning';
function isTransformCodeInterceptorGeneratedError(error) {
    return error
        && error.isAxiosError === true
        && typeof error._error_msg === 'string'
        && typeof error._error_code === 'number';
}
let WorkspaceHttpErrorHandler = class WorkspaceHttpErrorHandler {
    constructor() {
        Vue.config.errorHandler = function (err, vm, info) {
            setTimeout(() => {
                console.error(err, vm, info);
                throw err;
            });
        };
    }
    registerHandler(handlers) {
        handlers.register((error) => {
            if (error?.name === 'NavigationDuplicated') {
                return true;
            }
            return false;
        });
        handlers.register((error) => {
            if (isTransformCodeInterceptorGeneratedError(error)) {
                this._message.error({
                    message: error._error_msg,
                });
                return true;
            }
            return false;
        });
        handlers.register((error) => {
            if (isToastError(error)) {
                this._message.error({
                    message: error.message,
                });
                return true;
            }
            return false;
        });
        handlers.register((error) => {
            if (isToastWarning(error)) {
                this._message.warning({
                    message: error.message,
                    dangerouslyUseHTMLString: true,
                });
                return true;
            }
            return false;
        });
        handlers.register((error) => {
            if (isPsHttpError(error)) {
                const data = error.cause;
                const code = data.error_code || '400';
                const message = this._i18nService.te(`commonStatusCode.${code}`)
                    ? this._i18nService.t(`commonStatusCode.${code}`, data.error_params)
                    : this._i18nService.t('commonStatusCode.400');
                this._message.error({ message });
                return true;
            }
            console.error(error);
            return false;
        });
    }
};
__decorate([
    inject(I18nService),
    __metadata("design:type", typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object)
], WorkspaceHttpErrorHandler.prototype, "_i18nService", void 0);
__decorate([
    inject(Message),
    __metadata("design:type", typeof (_b = typeof Message !== "undefined" && Message) === "function" ? _b : Object)
], WorkspaceHttpErrorHandler.prototype, "_message", void 0);
WorkspaceHttpErrorHandler = __decorate([
    injectable(),
    __metadata("design:paramtypes", [])
], WorkspaceHttpErrorHandler);
export { WorkspaceHttpErrorHandler };
